import { useParams } from 'react-router-dom';
import { useLayoutContext } from 'contexts/LayoutContext';
import PageLoader from 'components/PageLoader';
import api from 'lib/trpcClient';
import { createLpCompanyRevaluationsRoute } from 'adminConstants/routes';
import RevaluationsFormContainer from './RevaluationsFormContainer';

const pageTitle = 'Holdings';

const Revaluations: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { vehicle } = useLayoutContext();

  const [asset] = api.asset.get.useSuspenseQuery({
    assetId: id,
    vehicleId: vehicle?._id ?? '',
  });

  const [revaluations] = api.asset.getAssetRevaluations.useSuspenseQuery({
    assetId: id,
    vehicleId: vehicle?._id ?? '',
  });

  const [assetFullHistory] = api.asset.getAssetFullHistory.useSuspenseQuery({
    assetId: id,
    vehicleId: vehicle?._id ?? '',
  });

  const [holdingClassInvestmentTotals] =
    api.asset.getAssetHoldingClassInvestmentTotals.useSuspenseQuery({
      assetId: id,
      vehicleId: vehicle?._id ?? '',
    });

  const [investmentHistory] = api.asset.getInvestmentHistory.useSuspenseQuery({
    assetId: id,
    vehicleId: vehicle?._id ?? '',
    order: 'desc',
    orderBy: 'dealCompletionDate',
  });

  const breadcrumbs = [
    { label: 'Dashboard' },
    { label: 'Companies', link: '/lp-companies/list' },
    {
      label: 'Revaluations',
      link: createLpCompanyRevaluationsRoute(id ?? ''),
    },
  ];

  if (!vehicle) {
    return <PageLoader />;
  }

  return (
    <RevaluationsFormContainer
      id={id ?? ''}
      pageTitle={pageTitle}
      breadcrumbs={breadcrumbs}
      vehicle={vehicle}
      asset={asset}
      revaluations={revaluations}
      investmentHistory={investmentHistory}
      assetFullHistory={assetFullHistory}
      holdingClassInvestmentTotals={holdingClassInvestmentTotals}
    />
  );
};

export default Revaluations;
